import { render, staticRenderFns } from "./CustomerEditor.vue?vue&type=template&id=7dd83bd8&scoped=true&"
import script from "./CustomerEditor.vue?vue&type=script&lang=ts&"
export * from "./CustomerEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerEditor.vue?vue&type=style&index=0&id=7dd83bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd83bd8",
  null
  
)

export default component.exports